import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f5a68596")

_pushScopeId("data-v-f5a68596")
const _hoisted_1 = { class: "search-container" }
const _hoisted_2 = {
  key: 0,
  class: "search-form-item"
}
const _hoisted_3 = { class: "form-label" }
const _hoisted_4 = { class: "search-form-item" }
const _hoisted_5 = { class: "form-label" }
const _hoisted_6 = { class: "search-form-item" }
const _hoisted_7 = { class: "form-label" }
const _hoisted_8 = { class: "search-form-item" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "el-icon-search" }, null, -1)
const _hoisted_10 = { style: {"margin-right":"8px"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_add_button = _resolveComponent("add-button")
  const _component_button_tip = _resolveComponent("button-tip")
  const _component_list_pagination = _resolveComponent("list-pagination")
  const _component_add_room_dialog = _resolveComponent("add-room-dialog")
  const _component_people_set_dialog = _resolveComponent("people-set-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.listRequestData.param.Build == 'community' || _ctx.listRequestData.param.DepartmentID != 'public')
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            (_ctx.isOffice)
              ? (_openBlock(), _createBlock("div", _hoisted_2, [
                  _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$wordList.ProperAllTextIdentity), 1),
                  _createVNode(_component_cus_select, {
                    modelValue: _ctx.listRequestData.param.Role,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.listRequestData.param.Role = $event))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_cus_option, {
                        label: _ctx.$wordList.SelectAll,
                        value: "all"
                      }, null, 8, ["label"]),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.identityOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_cus_option, {
                          key: item,
                          value: item.value,
                          label: item.label
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_4, [
              _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$wordList.ProperAllTextAppStatus), 1),
              _createVNode(_component_cus_select, {
                modelValue: _ctx.listRequestData.param.Status,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.listRequestData.param.Status = $event))
              }, {
                default: _withId(() => [
                  _createVNode(_component_cus_option, {
                    label: _ctx.$wordList.SelectAll,
                    value: "all"
                  }, null, 8, ["label"]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.statusOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item,
                      value: item.value,
                      label: item.label
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$wordList.ProperAllTextActive), 1),
              _createVNode(_component_cus_select, {
                modelValue: _ctx.listRequestData.param.Active,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.listRequestData.param.Active = $event))
              }, {
                default: _withId(() => [
                  _createVNode(_component_cus_option, {
                    label: _ctx.$wordList.SelectAll,
                    value: "all"
                  }, null, 8, ["label"]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.activeOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item,
                      value: item.value,
                      label: item.label
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_el_input, {
          class: "width400px",
          modelValue: _ctx.listRequestData.param.searchValue,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.listRequestData.param.searchValue = $event))
        }, {
          prepend: _withId(() => [
            _createVNode(_component_cus_select, {
              modelValue: _ctx.listRequestData.param.searchKey,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.listRequestData.param.searchKey = $event))
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.searchKeyList, (item) => {
                  return (_openBlock(), _createBlock(_component_cus_option, {
                    key: item,
                    value: item.name,
                    label: item.label
                  }, null, 8, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_cus_button, {
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateToList++))
      }, {
        default: _withId(() => [
          _hoisted_9,
          _createTextVNode(" " + _toDisplayString(_ctx.$wordList.LogInHtmlSearch), 1)
        ]),
        _: 1
      }),
      (_ctx.requestBuild != (_ctx.isOffice ? 'all' : 'community'))
        ? (_openBlock(), _createBlock(_component_add_button, {
            key: 1,
            class: "btn-right",
            onClick: _ctx.addRoom
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_list_pagination, {
      headers: _ctx.headers,
      requestData: _ctx.listRequestData,
      update: _ctx.updateToList,
      showCheck: false,
      saveParamInPath: true,
      showDefaultAction: ['edit', 'delete'],
      deleteUrl: _ctx.deleteUrl,
      onEdit: _ctx.userinfo
    }, {
      NameSlotHeader: _withId((data) => [
        _createVNode("div", {
          class: "sort-header",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getSortRes(
                    _ctx.isOffice ? (_ctx.listRequestData.param.DepartmentID==='all' ? 'officePeople' : 'departmentPeople')
                    : 'communityResidents',
                    'Name'
                )))
        }, [
          _createTextVNode(_toDisplayString(data.scope.label) + " ", 1),
          _createVNode("img", {
            src: _ctx.getSortImg(
                        _ctx.isOffice ? (_ctx.listRequestData.param.DepartmentID==='all' ? 'officePeople' : 'departmentPeople')
                        : 'communityResidents',
                        'Name'
                    )
          }, null, 8, ["src"])
        ])
      ]),
      EmployeeIDSlotHeader: _withId((data) => [
        _createVNode("div", {
          class: "sort-header",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getSortRes(
                    (_ctx.listRequestData.param.DepartmentID==='all' ? 'officePeople' : 'departmentPeople'),
                    'EmployeeID')))
        }, [
          _createTextVNode(_toDisplayString(data.scope.label) + " ", 1),
          _createVNode("img", {
            src: _ctx.getSortImg(
                        (_ctx.listRequestData.param.DepartmentID==='all' ? 'officePeople' : 'departmentPeople'),
                        'EmployeeID')
          }, null, 8, ["src"])
        ])
      ]),
      CreateTimeSlotHeader: _withId((data) => [
        _createVNode("div", {
          class: "sort-header",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getSortRes(
                    _ctx.isOffice ? (_ctx.listRequestData.param.DepartmentID==='all'?'officePeople':'departmentPeople')
                    : (_ctx.listRequestData.param.Build==='community'?'communityResidents':'buildApt'),
                    'CreateTime'
                )))
        }, [
          _createTextVNode(_toDisplayString(data.scope.label) + " ", 1),
          _createVNode("img", {
            src: _ctx.getSortImg(
                        _ctx.isOffice ? (_ctx.listRequestData.param.DepartmentID==='all'?'officePeople':'departmentPeople')
                        : (_ctx.listRequestData.param.Build==='community'?'communityResidents':'buildApt'),
                        'CreateTime'
                    )
          }, null, 8, ["src"])
        ])
      ]),
      RoomNameSlotHeader: _withId((data) => [
        _createVNode("div", {
          class: "sort-header",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.getSortRes('buildApt', 'Apt')))
        }, [
          _createTextVNode(_toDisplayString(data.scope.label) + " ", 1),
          _createVNode("img", {
            src: _ctx.getSortImg('buildApt', 'Apt')
          }, null, 8, ["src"])
        ])
      ]),
      RoomNumberSlotHeader: _withId((data) => [
        _createVNode("div", {
          class: "sort-header",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.getSortRes('buildApt', 'RoomNumber')))
        }, [
          _createTextVNode(_toDisplayString(data.scope.label) + " ", 1),
          _createVNode("img", {
            src: _ctx.getSortImg('buildApt', 'RoomNumber')
          }, null, 8, ["src"])
        ])
      ]),
      NameSlot: _withId((data) => [
        _createVNode("label", _hoisted_10, _toDisplayString(data.scope.Name), 1),
        (Number(data.scope.Role) === _ctx.account.personnelRole)
          ? (_openBlock(), _createBlock(_component_button_tip, {
              key: 0,
              color: "#676767",
              width: "90px"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextPersonnel), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_button_tip, { key: 1 }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.OfficeStaff), 1)
              ]),
              _: 1
            }))
      ]),
      _: 1
    }, 8, ["headers", "requestData", "update", "deleteUrl", "onEdit"]),
    (_ctx.isShowAddRoomDialog)
      ? (_openBlock(), _createBlock(_component_add_room_dialog, {
          key: 0,
          initForm: _ctx.formData,
          onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isShowAddRoomDialog = false)),
          onUpdate: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateToList++))
        }, null, 8, ["initForm"]))
      : _createCommentVNode("", true),
    (_ctx.isShowPeopleDialog)
      ? (_openBlock(), _createBlock(_component_people_set_dialog, {
          key: 1,
          initForm: _ctx.peopleData,
          operate: "add",
          onClose: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isShowPeopleDialog = false)),
          onUpdate: _cache[15] || (_cache[15] = ($event: any) => (_ctx.updateToList++))
        }, null, 8, ["initForm"]))
      : _createCommentVNode("", true)
  ]))
})